import { useNotification } from 'components/Notification'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  lockCustomerAuthorization,
  unlockCustomerAuthorization,
} from 'services/customerAuthorizations'
import { CUSTOMER_AUTHORIZATION_QUERY_KEY } from '../constants'
import { createMutationErrorHandler } from 'utils/notifications'
import useChangeScopeMutation from 'hooks/useChangeScopeMutation'

const useCustomerAuthorizationMutation = ({ customerId }) => {
  const { createNotification } = useNotification()
  const queryClient = useQueryClient()
  const createErrorNotification = createMutationErrorHandler(createNotification)
  const queryKey = [CUSTOMER_AUTHORIZATION_QUERY_KEY, customerId]

  const removeCustomerAuthorization = useMutation({
    mutationFn: lockCustomerAuthorization,
    onSuccess: () => {
      createNotification({ message: 'User removed from customer', variant: 'success' })
      queryClient.invalidateQueries({ queryKey })
    },
    onError: createErrorNotification,
  })

  const restoreCustomerAuthorization = useMutation({
    mutationFn: unlockCustomerAuthorization,
    onSuccess: () => {
      createNotification({ message: 'User restored to customer', variant: 'success' })
      queryClient.invalidateQueries({ queryKey })
    },
    onError: createErrorNotification,
  })

  const changeScopeOfCustomerAuthorization = useChangeScopeMutation({ queryKey })

  return {
    removeCustomerAuthorization,
    restoreCustomerAuthorization,
    changeScopeOfCustomerAuthorization,
  }
}

export default useCustomerAuthorizationMutation
